<div class="row">
    <div class="col-sm-12 ">
        <h1 class="mt-1 mb-1 p-0" (click)="sendToParent()">{{titlePage}}</h1>
    </div>
</div>